import { useCallback } from 'react';
import Request, { METHOD } from '../utils/Request';
import useRequestCallback from './useRequestCallback';

export function useSendFileToS3PreSignedPostUrlCallback() {
  const {
    callback,
    loading
  } = useRequestCallback(
    useCallback(async (ignore, {
      file,
      url,
      fields,
      onUploadProgress = () => {
        return false;
      }
    }) => {
      // FIXME - request instance is not aborted when multiple request.
      const request = new Request();
      const data = new FormData();
      Object.entries(fields).forEach(([keyField, valueField]) => {
        data.append(keyField, valueField);
      });
      data.append('file', file.file);
      return request.exec({
        method: METHOD.POST,
        path: url,
        formData: data,
        headers: {
          Vary: 'Access-Control-Request-Headers, Access-Control-Request-Method, Origin'
        },
        config: {
          omitTokenHeader: true,
          omitBaseHeaders: true,
          omitResponseCode: true,
          useCustomDomain: true,
          onUploadProgress: (progressEvent) => {
            onUploadProgress(progressEvent, request);
          }
        }
      });
    }, [])
  );
  return {
    callback,
    loading
  };
}

export default useSendFileToS3PreSignedPostUrlCallback;
